const MUTATION_TYPE = {
  setCurrentUser: 'setCurrentUser',
  setError: 'setError'
}

const ACTION_TYPE = {
  fetchCurrentUser: 'fetchCurrentUser',
  signIn: 'signIn',
  signOut: 'signOut'
}

const GETTER_TYPE = {
  getCurrentUser: 'getCurrentUser',
  isAuthenticated: 'isAuthenticated',
  hasRole: 'hasRole',
  getError: 'getError'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
